import { render, staticRenderFns } from "./PostAvatar.vue?vue&type=template&id=7bbd0b06"
import script from "./PostAvatar.vue?vue&type=script&lang=js"
export * from "./PostAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports